import { CashFlowExpenseAccountItem } from "bus/cash/types/cashFlowExpenseAccount";

export const initValue: CashFlowExpenseAccountItem = {
  cashFlowAccount: null,
  cashFlowId: null,
  cashFlowItemId: null,
  comment: '',
  contractorId: null,
  date: '',
  sum: 0
};